export default {
      id: "logo-google-24-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "assets/iconset.svg#logo-google-24",
      toString: function () {
        return this.url;
      }
    }